import { render } from "./DatasetModal.vue?vue&type=template&id=2cc69e22"
import script from "./DatasetModal.vue?vue&type=script&lang=js"
export * from "./DatasetModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__